import React from 'react';

const UnderDevelopmentLabel = () => {
  return <div className="inline-block text-xs rounded bg-red-600 text-white px-2 py-1">
    under development
  </div>
}

export { UnderDevelopmentLabel }
